import type { RouteRecordName } from '#vue-router'
import type { IconDefinition } from '@fortawesome/pro-light-svg-icons'
import { faBookmark, faBooks, faFileLines, faHighlighterLine, faScroll } from '@fortawesome/pro-light-svg-icons'
import { faSection } from '@fortawesome/pro-regular-svg-icons'

export interface TabMenuItem<T extends string> {
  value: T
  label: string
  icon?: IconDefinition
}

export const MENU_ITEM_OPTIONS = [
  {
    label: 'Favoritter',
    value: 'workspace-favoritter',
    icon: faBookmark,
  },
  {
    label: 'Markeringer',
    value: 'workspace-markeringer',
    icon: faHighlighterLine,
  },
] as const satisfies TabMenuItem<RouteRecordName>[]

export const LEGAL_CATEGORY_OPTIONS = [
  {
    label: 'Alle favoritter',
    value: 'alle-favoritter',
    icon: faBookmark,
  },
  {
    label: 'Lov og lovkommentar',
    value: 'lov-og-lovkommentar',
    icon: faSection,
  },
  {
    label: 'Faglitteratur',
    value: 'faglitteratur',
    icon: faBooks,
  },
  {
    label: 'Tidsskrifter',
    value: 'tidsskrifter',
    icon: faScroll,
  },
  {
    label: 'Maler',
    value: 'maler',
    icon: faFileLines,
  },
] as const satisfies TabMenuItem<string>[]

export const FAVORITES_CONTENT_TYPE_OPTIONS = LEGAL_CATEGORY_OPTIONS.filter(
  option => option.value !== 'alle-favoritter',
)

export const FAVORITES_SORTING_OPTIONS = [
  {
    value: 'kronologisk',
    label: 'Kronologisk',
  },
  {
    value: 'alfabetisk',
    label: 'Alfabetisk',
  },
] as const

export const MARKINGS_SORTING_OPTIONS = [
  {
    value: 'sist-markert',
    label: 'Sist markert',
  },
  {
    value: 'forst-markert',
    label: 'Først markert',
  },
  {
    value: 'kronologisk-i-teksten',
    label: 'Kronologisk i teksten',
  },
] as const

export const PUBLICATION_ITEM_OPTIONS = [
  {
    label: 'Alle utgivelser',
    value: 'alle',
  },
  {
    label: 'Lovkommentarer',
    value: 'lovkommentarer',
  },
  {
    label: 'Fagbøker',
    value: 'fagbøker',
  },
  {
    label: 'Fagartikler',
    value: 'fagartikler',
  },
  {
    label: 'Tidsskriftsartikler',
    value: 'tidsskriftsartikler',
  },
] as const satisfies TabMenuItem<string>[]
